/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const ponteNavigation: FuseNavigationItem[] = [
    {
        id: 'scrivania',
        title: 'SCRIVANIA',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'scrivania',
                title: 'Scrivania',
                type: 'basic',
                icon: 'heroicons_solid:building-library',
                link: 'scrivania'
            }
        ]
    },
    {
        id: 'censimento-anagrafica',
        title: 'Dati istanza',
        type: 'group',
        icon: 'heroicons_outline:clipboard-document',
        children: [
            {
                id: 'dati-richiedente',
                title: 'DATI RICHIEDENTE',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: 'dati-generali'
            },
            {
                id: 'tipo-richiedente',
                title: 'Tipo Richiedente',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: 'dati-generali'
            },
            {
                id: 'osservazioni',
                title: 'Osservazioni',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: 'dati-generali'
            }
        ]
    },
    {
        id: 'area-lavoro',
        title: 'Area di lavoro',
        type: 'group',
        children: [
            {
                id: 'comunicazione',
                title: 'Comunicazione generica',
                type: 'basic',
                icon: 'heroicons_outline:document-arrow-up',
                link: 'dati-localizzazione'
            },
            {
                id: 'richiesta-integrazione',
                title: 'Richieste di integrazione',
                type: 'basic',
                icon: 'heroicons_outline:document-arrow-up',
                link: 'dati-localizzazione'
            },
            {
                id: 'richiesta-pagamento',
                title: 'Ordinativo di pagamento',
                type: 'basic',
                icon: 'heroicons_outline:document-arrow-up',
                link: 'mappa-google'
            },
        ]
    },
    {
        id: 'autorizzazione',
        title: 'Autorizzazione',
        type: 'group',
        icon: 'heroicons_outline:clipboard-document',
        children: [

        ]
    },

    {
        id:'allegati',
        title:'DOCUMENTAZIONE ALLEGATA',
        type:'group',
        children:[
            {
                id:'file_allegati',
                title: 'Documenti allegati',
                type:'basic',
                icon: 'heroicons_outline:cloud',
                link: '/documentazione'
            },
        ]
    },
    {
        type: 'divider'
    },


    {
        type: 'divider'
    },
]




export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'scrivania',
        title: 'Scrivania',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/settore-risorse-umane'
    },
    {
        id   : 'accesso-lavoro-agile',
        title: 'Modulo Accesso lavoro agile',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/settore-risorse-umane/accesso-lavoro-agile'
    },
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    },
    {
        id   : 'academy',
        title: 'Academy',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : './academy'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example',
    }
];


export const istruttoreNavigation: FuseNavigationItem[] = [
    {
        id: 'scrivania_istruttore',
        title: 'SCRIVANIA ISTRUTTORE navigation',
        type: 'group',
        icon: 'heroicons_outline:building-library',
        children: [
            {
                id: 'scrivania',
                title: 'Scrivania istruttore',
                type: 'basic',
                icon: 'heroicons_outline:building-library',
                link: '/area-istruttore/scrivania',
                hidden:(item: FuseNavigationItem) =>{
                    return false
                },
                active:false,
                disabled:false,
                tooltip:"Questa è l'area istruttore",
                // fragment:'ciao',
            }
        ],
    },
    {
        id: 'area_lavoro_istruttore',
        title: 'AREA DI LAVORO',
        type: 'group',
        icon: 'heroicons_outline:document',
        children: [
            {
                id: 'area_lavoro',
                title: 'Area di lavoro',
                type: 'basic',
                icon: 'heroicons_outline:presentation-chart-line',
                link: './:id/dati-amministrativi'
            },
        ],
        hidden:(item: FuseNavigationItem) =>{
            return false
        },
        active:true

    },
    {
        id: 'messaggi_istruttore',
        title: 'MESSAGGI',
        type: 'group',
        // icon: 'heroicons_outline:document',
        children: [
            {
                id: 'messaggi',
                title: 'Messaggi',
                type: 'basic',
                icon: 'heroicons_outline:envelope',
                // link: 'spalle'
            },
        ],
    },
    {
        id: 'dati_istanza_istruttore',
        title: 'DATI ISTANZA',
        type: 'group',
        // icon: 'heroicons_outline:document',
        children: [
            {
                id: 'istanza_istrutt',
                title: 'Dati istanza',
                type: 'basic',
                icon: 'heroicons_outline:document',
                link: 'dati',
                preserveFragment: true
            },
        ],
    },
    {
        id: 'timeline_istruttore',
        title: 'TIMELINE',
        type: 'group',
        // icon: 'heroicons_outline:document',
        children: [
            {
                id: 'timeline',
                title: 'Timeline',
                type: 'basic',
                icon: 'heroicons_outline:clock',
                tooltip:"Guarda i tuoi eventi nell'ultimo periodo",
                // link: 'spalle'
            },
        ],
    },
    {
        id:'allegati_istruttore',
        title:'DOCUMENTAZIONE',
        type:'group',
        children:[
            {
                id:'file_allegati',
                title: 'Documenti allegati',
                type:'basic',
                icon: 'heroicons_outline:cloud',
                link: '/documentazione'
            },
        ]
    },
];

export const istanzaNavigation: FuseNavigationItem[] = [
    {
        id: 'scrivania_istruttore',
        title: 'SCRIVANIA ISTRUTTORE',
        type: 'group',
        icon: 'heroicons_outline:building-library',
        children: [
            {
                id: 'scrivania_istruttore',
                title: 'Scrivania istruttore',
                type: 'basic',
                icon: 'heroicons_outline:building-library',
                link: '/area-istruttore/scrivania',
                hidden:(item: FuseNavigationItem) =>{
                    return false
                },
                active:false,
                disabled:false,
                tooltip:'dsjdjosdsj',
                fragment:'',
            }
        ],
    },
    {
        id: 'cronologia',
        title: 'ULTIME CONSULTATE',
        type: 'group',
        // icon: 'heroicons_outline:document',
        children: [

        ],
    }

];

export const horizontalNavigation: FuseNavigationItem[] = [


    {
        id: 'scrivania_istruttore',
        title: 'SCRIVANIA ISTRUTTORE',
        type: 'group',
        icon: 'heroicons_outline:building-library',
        children: [
            {
                id: 'scrivania',
                title: 'Scrivania istruttore',
                type: 'basic',
                icon: 'heroicons_outline:building-library',
                link: '/area-istruttore/scrivania',
                hidden:(item: FuseNavigationItem) =>{
                    return false
                },
                active:false,
                disabled:false,
                tooltip:"Questa è l'area istruttore",
                // fragment:'ciao',
            }
        ],
    },
    {
        id: 'area_lavoro_istruttore',
        title: 'AREA DI LAVORO',
        type: 'group',
        icon: 'heroicons_outline:document',
        children: [
            {
                id: 'area_lavoro',
                title: 'Area di lavoro',
                type: 'basic',
                icon: 'heroicons_outline:presentation-chart-line',
                link: 'dati-amministrativi'
            },
        ],
        hidden:(item: FuseNavigationItem) =>{
            return false
        },
        active:true

    },
    {
        id: 'messaggi_istruttore',
        title: 'MESSAGGI',
        type: 'group',
        // icon: 'heroicons_outline:document',
        children: [
            {
                id: 'messaggi',
                title: 'Messaggi',
                type: 'basic',
                icon: 'heroicons_outline:envelope',
                // link: 'spalle'
            },
        ],
    },
    {
        id: 'dati_istanza_istruttore',
        title: 'DATI ISTANZA',
        type: 'group',
        // icon: 'heroicons_outline:document',
        children: [
            {
                id: 'istanza_istrutt',
                title: 'Dati istanza',
                type: 'basic',
                icon: 'heroicons_outline:document',
                link: 'dati',
                preserveFragment: true
            },
        ],
    },
    {
        id: 'timeline_istruttore',
        title: 'TIMELINE',
        type: 'group',
        // icon: 'heroicons_outline:document',
        children: [
            {
                id: 'timeline',
                title: 'Timeline',
                type: 'basic',
                icon: 'heroicons_outline:clock',
                tooltip:"Guarda i tuoi eventi nell'ultimo periodo",
                // link: 'spalle'
            },
        ],
    },
    {
        id:'allegati_istruttore',
        title:'DOCUMENTAZIONE',
        type:'group',
        children:[
            {
                id:'file_allegati',
                title: 'Documenti allegati',
                type:'basic',
                icon: 'heroicons_outline:cloud',
                link: '/documentazione'
            },
        ]
    },

];


export const sanlazzaroNavigation: FuseNavigationItem[] = [
    {
        id   : 'academy',
        title: 'Academy',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/academy'
    },
    {
        id   : 'scrivania',
        title: 'Scrivania',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/settore-risorse-umane'
    },
    {
        id   : 'accesso-lavoro-agile',
        title: 'Modulo Accesso lavoro agile',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/settore-risorse-umane/accesso-lavoro-agile'
    },
    {
        id   : 'osservazioni-pug',
        title: 'Modulo Osservazioni Pug',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-list',
        link : '/settore-urbanistica/osservazioni-pug'
    },
    {
        id   : 'scrivania-pug',
        title: 'Scrivania Pug',
        type : 'basic',
        icon : 'heroicons_outline:table-cells',
        link : '/settore-urbanistica'
    },
];

export const sanlazzaroPortaleNavigation: FuseNavigationItem[] = [
    {
        id   : 'amministrazione',
        title: 'Amministrazione',
        type : 'basic',
        link : "https://www.comune.sanlazzaro.bo.it/amministrazione-trasparente",
        externalLink:true,
    },
    {
        id   : 'novita',
        title: 'Novità',
        type : 'basic',
        link : "https://www.comune.sanlazzaro.bo.it/novita",
        externalLink:true,
        classes:{
            wrapper:'mr-2'
        }
    },
    {
        id   : 'servizi',
        title: 'Servizi',
        type : 'basic',
        link : 'https://www.comune.sanlazzaro.bo.it/servizi',
        externalLink:true,
        classes:{
            wrapper:'mr-2'
        }
    },
    {
        id   : 'vivere-sl',
        title: 'Vivere San Lazzaro',
        type : 'basic',
        link : 'https://www.comune.sanlazzaro.bo.it/vivere-san-lazzaro-di-savena',
        externalLink:true,
        classes:{
            wrapper:'mr-40'
        }
    },
    {
        type : 'spacer',
        classes: {
            wrapper: 'px-20'
        }
    },
    {
        id   : 'amministrazione_trasparente',
        title: 'Ammministrazione trasparente e PNRR',
        type : 'basic',
        link : 'https://www.comune.sanlazzaro.bo.it/amministrazione-trasparente',
        externalLink:true,
        classes:{
            wrapper:'mr-2'
        }
    },
    {
        id   : 'tutti-argomenti',
        title: 'Tutti gli argomenti',
        type : 'basic',
        link : 'https://www.comune.sanlazzaro.bo.it/argomenti',
        externalLink:true,
    }
];
